// extracted by mini-css-extract-plugin
export default {"inputContainer":"ChatInput_inputContainer__gDDee","input":"ChatInput_input__DrJuk","sendButton":"ChatInput_sendButton__YK1or"};